import React, { useEffect, useState } from "react";
import {
  AdMob,
  InterstitialAdPluginEvents,
  RewardAdPluginEvents,
  BannerAdPluginEvents,
} from "@capacitor-community/admob";
import { showConsent, showToast } from "./utils";
import { useFunctions } from "reactfire";
import { useUser } from "reactfire";
import { httpsCallable } from "firebase/functions";

function AdMobComponent() {
  const [listenerHandlers, setListenerHandlers] = useState([]);
  const { data: user } = useUser();

  console.log(user);

  const functions = useFunctions();

  const updateCredits = httpsCallable(functions, "updateCredits", {
    timeout: 530000,
  });

  async function callUpdateCredits(amount, type) {
    if (!user.uid) return;
    if (!amount) return;
    if (!type) return;
    let data = {
      userId: user.uid,
      credits: amount,
      type: type,
    };
    try {
      await updateCredits(data);
      showToast("Success!");
      console.log(amount + " - " + type);
    } catch (error) {
      console.log(error);
    }
  }

  const registerListeners = (eventKeys, eventCategory) => {
    eventKeys.forEach((key) => {
      const handler = AdMob.addListener(eventCategory[key], (value) => {
        // Handle the event data as needed
        handleEvent({ name: key, value });
      });
      setListenerHandlers((prevHandlers) => [...prevHandlers, handler]);
    });
  };

  const handleEvent = (eventData) => {
    if (eventData.name === "Rewarded") {
      const { value } = eventData;

      callUpdateCredits(value.amount, value.type);
    }
  };

  async function initializeAdMob() {
    const { status } = await AdMob.trackingAuthorizationStatus();

    if (status === "notDetermined") {
    }

    AdMob.initialize({
      /*       testingDevices: ["2077ef9a63d2b398840261c8221a0c9b"],
      initializeForTesting: true, */
      requestTrackingAuthorization: true,
    });

    await showConsent();
  }

  useEffect(() => {
    if (!user?.uid) {
      return;
    }
    initializeAdMob();
    registerListeners(
      Object.keys(InterstitialAdPluginEvents),
      InterstitialAdPluginEvents
    );

    registerListeners(Object.keys(RewardAdPluginEvents), RewardAdPluginEvents);

    registerListeners(Object.keys(BannerAdPluginEvents), BannerAdPluginEvents);

    // Cleanup event listeners on unmount
    return () => {
      listenerHandlers.forEach((handler) => {
        handler.remove();
      });
    };
  }, [user?.uid]);

  useEffect(() => {}, []);

  return null;
}

export default AdMobComponent;
